module.exports = __webpack_public_path__ + "img/webase3.33b16eeb.png";